"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.NativeDriveRemoteContentFactory = exports.ToolboxDriveRemoteContentFactory = exports.BaseDriveRemoteContentFactory = void 0;
var native_1 = require("./native");
var toolbox_1 = require("./toolbox");
var namesHelper_1 = require("../../namesHelper");
var BaseDriveRemoteContentFactory = /** @class */ (function () {
    function BaseDriveRemoteContentFactory(portalUserId) {
        this.portalUserId = portalUserId;
    }
    BaseDriveRemoteContentFactory.prototype.createByUrl = function (contentUrl) {
        return this.createByPath(namesHelper_1.DriveNamesHelper.buildContentNameByUrl(contentUrl));
    };
    BaseDriveRemoteContentFactory.prototype.createByHash = function (contentHash, options) {
        return this.createByPath(namesHelper_1.DriveNamesHelper.buildContentName(contentHash, this.portalUserId, options === null || options === void 0 ? void 0 : options.srv, options === null || options === void 0 ? void 0 : options.nsid));
    };
    return BaseDriveRemoteContentFactory;
}());
exports.BaseDriveRemoteContentFactory = BaseDriveRemoteContentFactory;
var ToolboxDriveRemoteContentFactory = /** @class */ (function (_super) {
    __extends(ToolboxDriveRemoteContentFactory, _super);
    function ToolboxDriveRemoteContentFactory(portalUserId, toolbox, driveClient, driveSettings) {
        var _this = _super.call(this, portalUserId) || this;
        _this.toolbox = toolbox;
        _this.driveClient = driveClient;
        _this.driveSettings = driveSettings;
        _this.version = "tb";
        _this.toolbox.getInfo().then(function (info) { return (_this.version += info.version); });
        return _this;
    }
    ToolboxDriveRemoteContentFactory.prototype.createByPath = function (contentName) {
        return new toolbox_1.ToolboxDriveRemoteContent(this.toolbox, this.driveClient, this.driveSettings, contentName, this.version);
    };
    return ToolboxDriveRemoteContentFactory;
}(BaseDriveRemoteContentFactory));
exports.ToolboxDriveRemoteContentFactory = ToolboxDriveRemoteContentFactory;
var NativeDriveRemoteContentFactory = /** @class */ (function (_super) {
    __extends(NativeDriveRemoteContentFactory, _super);
    function NativeDriveRemoteContentFactory(portalUserId, driveClient, driveSettings) {
        var _this = _super.call(this, portalUserId) || this;
        _this.driveClient = driveClient;
        _this.driveSettings = driveSettings;
        return _this;
    }
    NativeDriveRemoteContentFactory.prototype.createByPath = function (contentName) {
        var version = "blob";
        return new native_1.NativeDriveRemoteContent(this.driveClient, contentName, this.driveSettings, version);
    };
    return NativeDriveRemoteContentFactory;
}(BaseDriveRemoteContentFactory));
exports.NativeDriveRemoteContentFactory = NativeDriveRemoteContentFactory;
